import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import './index.css';
import PrivateLessonsPlans from './pages/PrivateLessonsPlans';
import AcademyClassesPlans from './pages/AcademyClassesPlans';
import EnrollmentForm from './pages/EnrollmentForm';
import EnrollmentSuccess from './pages/EnrollmentSuccess';
import ScrollToTop from './components/ScrollToTop';
import WhatsAppFloat from './components/WhatsAppFloat';
function App() {
  return (
    <Router>
      <ScrollToTop />
      <WhatsAppFloat phoneNumber="971522390957" />
      <div className="min-h-screen bg-white">
        <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/private-lessons-plans" element={<PrivateLessonsPlans />} />
            <Route path="/academy-classes-plans" element={<AcademyClassesPlans />} />
            <Route path="/enrollment-form" element={<EnrollmentForm />} />
            <Route path="/enrollment-success" element={<EnrollmentSuccess />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;